import request from '@/router/axios';
/**
 * 根据服务名获取数据字典
 * @param {*} params 
 * @param {*} params.service
 */
export const selectDictByService = (params = {}) => {
    return request('/api/system/dict/select/service', {
        params
    });
};

export const getMajorDictTree = () => {
    return request('/api/system/dict/list');
};
